<template>
  <el-dialog
    :visible.sync="showProgressDialog"
    width="15%"
    title="上传中,请稍等"
    append-to-body
    top="40vh"
    center
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div class="com-layout-c-c-c">
      <el-progress
        type="circle"
        :percentage="formatUploadPercentage(percent)"
      ></el-progress>
    </div>
  </el-dialog>
</template>
<script>
export default {
  computed: {},
  data() {
    return {
      percent: 0, //上传进度
      showProgressDialog: false
    };
  },

  methods: {
    show() {
       this.percent = 0, //上传进度
      this.showProgressDialog = true;
    },
    refreshPercent(percent) {
      this.percent = percent;
    },
    dismisss() {
      console.log("dismisss");
      this.showProgressDialog = false;
    },
    // 格式化文件上传进度
    formatUploadPercentage(percentage) {
      return parseInt(percentage);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/common.scss";
</style>



// WEBPACK FOOTER //
// src/components/common/eduUI/loadingProgressDialog.vue